import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import OnboardingPlannerViewSectionHeader
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Components/OnboardingPlannerViewSectionHeader';
import { useOnboardingPlannerViewSectionContext } from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/ViewSectionContext';
import { FDBox } from '@facet-wealth/design';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';

const ViewSectionLayout = () => {
  const {
    resource,
  } = useMetaLayoutContext();

  const {
    onAddTask,
    onAddNote,
  } = useOnboardingPlannerViewSectionContext();

  return (
    <FDBox paddingX={3}>
      <OnboardingPlannerViewSectionHeader
        title={resource.attr('title')}
        onAddTask={onAddTask}
        onAddNote={onAddNote}
      />
      <MetaCollectionFormInline
        collection={resource.attr('sectionData')}
        FormProps={{
          noIndividualSubmitButtons: true,
          LayoutProps: {
            hideErrorList: true,
          },
          FieldListProps: {
            hideErrorList: true,
          },
          component: ({ children }) => children,
        }}
      />

    </FDBox>
  );
};

ViewSectionLayout.propTypes = {
};

ViewSectionLayout.defaultProps = {
};

export default ViewSectionLayout;
